module.exports = __webpack_public_path__ + "static/media/error.16f8a861.svg";